import axios from "axios";
import { trackAudienceEvent } from "../components/LiveAudienceTracker";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "archive_session_id";

const readSession = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw) {
      const { id } = JSON.parse(raw);
      return id || null;
    }
  } catch (_) { /* noop */ }
  return null;
};

const hostFromUrl = (url) => {
  try {
    const u = new URL(url, window.location.origin);
    const h = u.hostname.toLowerCase();
    return h.startsWith("www.") ? h.slice(4) : h;
  } catch (_) { return null; }
};

/**
 * Fire-and-forget outbound click beacon. Uses sendBeacon when available so
 * the request survives navigation. Never blocks or throws.
 */
export const trackOutboundClick = (url, opts = {}) => {
  if (!url || typeof url !== "string") return;
  if (!/^https?:\/\//i.test(url)) return;

  const payload = {
    url,
    host: opts.host || hostFromUrl(url),
    topic_id: opts.topic_id || null,
    topic_slug: opts.topic_slug || null,
    link_type: opts.link_type || "external",
    source_index: typeof opts.source_index === "number" ? opts.source_index : null,
    publisher: opts.publisher || null,
    stance: opts.stance || null,
    session: readSession(),
    ref_path: typeof window !== "undefined" ? window.location.pathname : null,
  };

  try {
    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
      const ok = navigator.sendBeacon(`${API}/analytics/outbound-click`, blob);
      if (ok) {
        try {
          trackAudienceEvent("source_click", {
            label: payload.publisher || payload.host || url,
            meta: payload.link_type || "external",
          });
        } catch (_) { /* silent */ }
        return;
      }
    }
  } catch (_) { /* fall through */ }

  // Fallback: axios fire-and-forget
  try {
    axios.post(`${API}/analytics/outbound-click`, payload, { timeout: 3000 })
      .catch(() => { /* silent */ });
    try {
      trackAudienceEvent("source_click", {
        label: payload.publisher || payload.host || url,
        meta: payload.link_type || "external",
      });
    } catch (_) { /* silent */ }
  } catch (_) { /* silent */ }
};

export default trackOutboundClick;
